// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import dataTableStyles from "@pace/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { recentQuotesStyles } from "@pace/Overrides/Widgets/Common/RecentQuotes";
import { xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

recentQuotesStyles.sectionWrapperStyles = {
    wrapper: {
        css: css`
            & > div {
                height: 100%;
            }
        `,
    },
};

recentQuotesStyles.noQuotesGridItem = {
    ...dataTableStyles.noResultsContainer,
};
recentQuotesStyles.noQuotesText = {
    ...dataTableStyles.noResultsText,
};
recentQuotesStyles.quoteNumberTableHeader = {
    css: css`
        width: 142px;
    `,
};
recentQuotesStyles.statusTableHeader = {
    css: css`
        width: 128px;
    `,
};
recentQuotesStyles.jobNameTableHeader = {
    css: css`
        width: 241px;
    `,
};
recentQuotesStyles.dateTableHeader = {
    css: css`
        width: 106px;
    `,
};
recentQuotesStyles.qtyTableHeader = {
    css: css`
        width: 96px;
    `,
};
recentQuotesStyles.totalTableHeader = {
    css: css`
        width: 142px;
    `,
};
recentQuotesStyles.actionTableHeader = {
    css: css`
        width: 142px;
    `,
};

recentQuotesStyles.quoteSummaryCard = {
    dataCells: {
        css: css`
                word-break: break-word;
            ${xScreen("gt", "md")} {
                white-space: pre-wrap;
            }
        `,
    },
};
